import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async listarLegislacoes ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `legislacao/list`
    })
    return data
  },
  async getByTexto ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      contentType: 'application/json',
      dataType: 'json',
      url: `legislacao/getByTexto`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/legislacao.js